import styled from 'styled-components'

export const RowContainer = styled.div<{ hideBorder?: boolean }>`
  display: flex;
  flex-direction: row;

  width: 100%;

  border-top: ${({ hideBorder }) => (hideBorder ? 'none' : '1px solid var(--Border-Neutral-faded, #dfe2ea)')};

  :first-child {
    border-top: none;
  }
`

export const SectionActions = styled.div`
  padding: 16px;

  box-sizing: border-box;
  display: flex;
  align-self: start;
  justify-content: end;

  div {
    padding: 8px;
    cursor: pointer;
  }
`

export const SectionContainer = styled.div`
  flex: 1;
  padding: 16px;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const SectionTitle = styled.div`
  color: var(--Foreground-Neutral, #14171f);

  /* Body 3/Medium */
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
`

export const ValueContainer = styled.div`
  display: flex;
  flex-direction: row;
  /* align-items: center; */
  gap: 6px;
`

export const ValueLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;

  color: var(--Foreground-Neutral-faded, #4d5874);

  /* Body 3/Regular */
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`

export const IconImg = styled.div`
  display: flex;
  align-items: center;

  opacity: 0.6;

  width: 16px;
  height: 16px;

  margin-top: 2px;

  svg {
    width: 16px;
    height: 16px;
  }
`

export const LocalizationContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  overflow: hidden;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  position: relative;

  border-radius: 8px;
  border: 1px solid #dfe2ea;

  padding: 0 6px 0 0;

  * {
    cursor: pointer !important;
  }
`

export const ArrowRightIcon = styled.img`
  height: 20px;
  width: 20px;
  display: flex;
  align-self: center;
`

export const TextButtonLocalization = styled.button`
  color: var(--Foreground-Primary, #4d4be7);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  padding: 0;

  background: transparent;
  border: none;
  cursor: pointer;

  display: flex;
  gap: 8px;
  align-items: center;
`

export const ProgressContainer = styled.div`
  padding: 16px;
  box-sizing: border-box;

  display: flex;
  flex-direction: row;
  gap: 8px;
`

export const ProgressPercentage = styled.div`
  color: var(--Foreground-Neutral-faded, #4d5874);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`
